import React, { useMemo } from 'react'
import { CellRenderers } from 'utils/tableUtils'
import GenericPullConfigListing from '../GenericPullConfigListing'
import CheckmarxCredentialsForm from './CheckmarxCredentialsForm'
import CheckmarxMappingForm from './CheckmarxMappingForm'
import _ from 'lodash'
import { Typography } from 'antd'
import ContentOverlay from 'components/ContentOverlay'

export default function CheckmarxConfigListing(props) {
    const columns = useMemo(() => [{
        title: "Project",
        dataIndex: "projectName",
        width: 240,
        render: (projectName, record) => {
            const projectIds = _.split(record.projectId, ",");
            const projectNames = _.split(projectName, ",");
            const content = projectNames.map((item, i) => {
                    return (
                        <p>
                            <Typography.Link
                                href={`/user/tools/generic/project/${props.name}/redirect?login_id=${record.login_id}&name=${projectIds[i]}`}
                                className='m-b-xs'
                                target='_blank'
                            >
                                {item}
                            </Typography.Link>
                        </p>
                    );
                })
            return <ContentOverlay content={content} minHeight={40} />;
        }
    },
    {
        title: "Team",
        dataIndex: "teamName",
        width: 240,
        render: CellRenderers.VALUE_OR_NA
    }], [props.name]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={CheckmarxMappingForm}
            CredentialsForm={CheckmarxCredentialsForm}
            extraColumns={columns}
        />
    )
}